// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import translations from './data.json';

Vue.use(VueI18n);

let language = window.language.split('-')[0];

const i18n = new VueI18n({
  locale: language, // Default language
  fallbackLocale: 'cs',
  messages: translations,
});

export default i18n;



// WEBPACK FOOTER //
// ./i18n.js